import { CourseEvents } from '~/enums/tracking/tracking-events.enums';

export default function useTrackingCourse () {
  const { dispatchTrackingEvent } = useTracking();

  const resourceDownloaded = (course: Course | null, resource: LearningResource) => {
    if (!course) {
      console.warn('Course is empty, could not track resourceDownloaded');
      return;
    }

    dispatchTrackingEvent(CourseEvents.ResourceDownloaded, {
      'file_name': resource.name,
      'file_type': resource.type,
      'course_name': course.courseTitle,
      'course_id': course.id,
    });
  };

  const courseBookmarked = (course: Course) => {
    dispatchTrackingEvent(CourseEvents.CourseBookmarked, {
      'course_id': course.id,
      'course_name': course.courseTitle,
      'type': course.type,
    });
  };

  return {
    resourceDownloaded,
    courseBookmarked,
  };
}
